export default __webpack_public_path__ + "static/genopets-3-b-e8e3f6acf17179b28b837b0a87613426.webp";